import { render } from "./DefaultButtons.vue?vue&type=template&id=2ffbd646&ts=true"
import script from "./DefaultButtons.vue?vue&type=script&lang=ts"
export * from "./DefaultButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__